/**
 *
 * OnDemandTripBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import OnDemandIcon from '../../../../assets/v2/OnDemandIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlue};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.skyBlue};
    }
  }
`;

function OnDemandTripBadge(props) {
  return (
    <StyledBadge
      icon={<OnDemandIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(OnDemandTripBadge);
